import {ComponentFactoryResolver, Directive, Input, OnInit, ViewContainerRef} from '@angular/core';
import {FieldConfig} from "@biletix/core/models/base/field-config.model";
import {FormGroup} from "@angular/forms";
import {BtxInputComponent} from "@biletix/shared/components/dynamic-form/btx-input/btx-input.component";
import {BtxSelectComponent} from "@biletix/shared/components/dynamic-form/btx-select/btx-select.component";
import {BtxDateComponent} from "@biletix/shared/components/dynamic-form/btx-date/btx-date.component";
import {BtxCheckBoxComponent} from "@biletix/shared/components/dynamic-form/btx-check-box/btx-check-box.component";
import {BtxRadioButtonComponent} from "@biletix/shared/components/dynamic-form/btx-radio-button/btx-radio-button.component";
import {BtxPhoneInputComponent} from "@biletix/shared/components/dynamic-form/btx-phone-input/btx-phone-input.component";
import {BtxPhotoInputComponent} from "@biletix/shared/components/dynamic-form/btx-photo-input/btx-photo-input.component";
import {BtxHesCodeInputComponent} from "@biletix/shared/components/dynamic-form/btx-hes-code-input/btx-hes-code-input.component";
import {VodafoneProfileValidatorComponent} from "@biletix/features/performance/components/performance-page/ticket-content-viewport/ticket-selection-content/ticket-profile-validation/validators/vodafone-profile-validator/vodafone-profile-validator.component";
import {TurkcellProfileValidatorComponent} from "@biletix/features/performance/components/performance-page/ticket-content-viewport/ticket-selection-content/ticket-profile-validation/validators/turkcell-profile-validator/turkcell-profile-validator.component";
import {AveaProfileValidatorComponent} from "@biletix/features/performance/components/performance-page/ticket-content-viewport/ticket-selection-content/ticket-profile-validation/validators/avea-profile-validator/avea-profile-validator.component";
import {TokenProfileValidatorComponent} from "@biletix/features/performance/components/performance-page/ticket-content-viewport/ticket-selection-content/ticket-profile-validation/validators/token-profile-validator/token-profile-validator.component";
import {CreditCardProfileValidatorComponent} from "@biletix/features/performance/components/performance-page/ticket-content-viewport/ticket-selection-content/ticket-profile-validation/validators/credit-card-profile-validator/credit-card-profile-validator.component";
import {MembershipProfileValidatorComponent} from "@biletix/features/performance/components/performance-page/ticket-content-viewport/ticket-selection-content/ticket-profile-validation/validators/membership-profile-validator/membership-profile-validator.component";
import { HopiTokenProfileValidatorComponent } from '@biletix/features/performance/components/performance-page/ticket-content-viewport/ticket-selection-content/ticket-profile-validation/validators/hopi-token-profile-validator/hopi-token-profile-validator.component';


const componentMapper =
    {
        DEFAULT_INPUT: VodafoneProfileValidatorComponent,
        TURKCELL: TurkcellProfileValidatorComponent,
        AVEA: AveaProfileValidatorComponent,
        TOKEN: TokenProfileValidatorComponent,
        CREDITCARD: CreditCardProfileValidatorComponent,
        MEMBER: MembershipProfileValidatorComponent,
        HOPI: HopiTokenProfileValidatorComponent
    };

@Directive({
    selector: '[dynamicField]',
  standalone: false
})
export class DynamicFieldDirective implements OnInit {

    @Input() fields: FieldConfig[] | undefined;
    @Input() group: FormGroup | any;

    componentRef: any;
    fieldKeys: (string | undefined)[] = [];
    field:FieldConfig|undefined;
    constructor(
        private resolver: ComponentFactoryResolver,
        private container: ViewContainerRef) {
    }


    ngOnInit() {
      console.log(this.fields)
      if (this.fields) {
        this.fieldKeys = this.fields!.map(f => f.key);
        if (this.fieldKeys.includes(this.group.value.key)) {
           this.fields!.filter(f => f.key === this.group.value.key && f.profileId === this.group.value.profileId ).forEach(field => {
             this.field = field;
             const factory = this.resolver.resolveComponentFactory(this.getComponent());
             this.componentRef = this.container.createComponent(factory);
             this.componentRef.instance.field = this.field;
             this.componentRef.instance.group = this.group;
          });
        }
      }

    }


    /**
     * Başka komponentlere ihtiyaç duyulduğunda eklenebilir
     */
    getComponent() {
        let component: any = BtxInputComponent;
        switch (this.field!.type?.toLowerCase()) {
            case "input":
            case "plate":
            case "tckno":
            case "password":
            case "number":
            case "text":
                component = BtxInputComponent;
                break;
            case "phone":
            case "tel":
            case "telephone":
                component = BtxPhoneInputComponent;
                break;
            case "select":
                component = BtxSelectComponent;
                break;
            case "date":
            case "datetime":
                component = BtxDateComponent;
                break;
            case "checkbox":
            case "check":
                component = BtxCheckBoxComponent;
                break;
            case "photo":
            case "image":
                component = BtxPhotoInputComponent;
                break;
            case "heskod":
                component = BtxHesCodeInputComponent;
                break;
            case  "gender":
            case "radio":
            case "radiobutton":
                component = BtxRadioButtonComponent;
                break;
        }
        return component;
    }
}
